export const GET_MILLESIME_IN_TRADE_REQUEST = "GET_MILLESIME_IN_TRADE_REQUEST"
export const GET_MILLESIME_IN_TRADE_SUCCESS = "GET_MILLESIME_IN_TRADE_SUCCESS"
export const GET_MILLESIME_IN_TRADE_FAILURE = "GET_MILLESIME_IN_TRADE_FAILURE"
